import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { getUser } from '../../reducers/userReducer';
import * as Features from '../../shared/Features';

export function withFeatureCheck(WrappedComponent: any, feature?: string | string[]) {
    class WithFeatureCheck extends React.Component<any, any> {
        hasAccess = () => {
            const { user } = this.props;
            if (!feature) {
                return true;
            }

            return Array.isArray(feature)
                ? Features.hasAnyFeature(feature, user)
                : Features.hasFeature(feature, user);
        };

        render() {
            if (!this.hasAccess()) {
                return <Redirect to="/" />;
            }

            return <WrappedComponent {...this.props} />;
        }
    }

    const mapStateToProps = (state) => ({
        user: getUser(state)
    });

    return compose(connect(mapStateToProps), withRouter)(WithFeatureCheck);
}
